import { FC, SVGProps } from 'react'
import * as Flags from 'country-flag-icons/react/3x2'
import { resolveCountryCode } from 'src/utils/resolveCountryCode'

interface CountryFlagProps {
  className?: string
  code?: string
  name?: string
}

// Renders a real flag SVG (works on every OS, unlike regional-indicator emoji
// which don't render on Windows). Resolves the ISO code from `code` or `name`;
// renders nothing when it can't be resolved or has no matching flag asset.
export const CountryFlag: FC<CountryFlagProps> = ({
  className,
  code,
  name,
}) => {
  const iso = resolveCountryCode(code, name)
  if (!iso) return null
  const Flag = (Flags as Record<string, FC<SVGProps<SVGSVGElement>>>)[iso]
  if (!Flag) return null
  return <Flag className={className} />
}
